import React from 'react';
import { truncate } from '../../lib/stringHelpers';

interface TruncateProps {
  text: string;
  maxLength?: number;
}

export const Truncate: React.FC<TruncateProps> = ({ text, maxLength = 6 }) => {
  const isTruncated = text.length > maxLength;
  return <span title={isTruncated ? text : undefined}>{truncate(text, maxLength)}</span>;
};
